import React from "react";

function PopupBlock({ onClose }) {

   const disableRightClick = (e) => {
    e.preventDefault();
  };

  return (
    <div onContextMenu={disableRightClick}
      className="modal show d-block"
      tabIndex="-1"
      role="dialog"
      style={{ backgroundColor: "rgba(0,0,0,0.6)" }}
      onClick={()=>onClose(false)}
    >
      <div className="modal-dialog modal-dialog-centered" onClick={(e) => e.stopPropagation()}>
        <div className="modal-content">

          {/* Header */}
          <div className="modal-header">
            <h5 className="modal-title">Confirmation</h5>
            <button type="button" className="btn-close" onClick={() => onClose(false)}></button>
          </div>

          {/* Body */}
          <div className="modal-body text-center">
            <p>Are you sure you want to block this user?</p>
          </div>

          {/* Footer */}
          <div className="modal-footer justify-content-center">
            <button className="btn btn-secondary" onClick={() => onClose(false)}>
              No
            </button>

            <button
              className="btn btn-danger"
              onClick={() => onClose(true)}
            >
              Yes
            </button>
          </div>

        </div>
      </div>
    </div>
  );
}

export default PopupBlock;